<script lang="ts">
    import { getState } from "./context";

    const state = getState();
    $: uiState = $state.machineState.uiState;
</script>

<div>
    EditMode: {uiState.editMode}

    <!-- {#if uiState.editMode === 'EXECUTION_SINGLE_STEP' && $state.machineState.executionState && $state.machineState.type === 'Mealy'}
        {$state.machineState.executionState.currentMachineState.name}
    {/if} -->
</div>